import {
  isMapboxURL,
  transformMapboxUrl,
} from "maplibregl-mapbox-request-transformer";

/**
 * This is a public access token connected to THE CITY's MapBox account:
 */
export const MAPBOX_TOKEN =
  "pk.eyJ1IjoidGhlLWNpdHkiLCJhIjoiY2xhMWVuaDNqMDZ1ZzNxbzNkM3poMHBheSJ9.SJAnL4rHAR6jShHQniZZHg";

/**
 * This is a link to our custom MapBox Studio basemap style:
 */
export const MAPBOX_STYLE_URL =
  "mapbox://styles/the-city/cla76ue2h001514o67feib2ey";

/**
 * Since our custom style does not include links for map sprites, let's specify a fallback map style to load in:
 */
const FALLBACK_STYLE_URL_ROOT =
  "https://tiles.basemaps.cartocdn.com/gl/positron-gl-style/sprite@2x";

export const transformStyleRequest = (url, resourceType) => {
  if (resourceType === "SpriteImage") {
    return {
      url: `${FALLBACK_STYLE_URL_ROOT}.png`,
    };
  }
  if (resourceType === "SpriteJSON") {
    return {
      url: `${FALLBACK_STYLE_URL_ROOT}.json`,
    };
  }
  if (isMapboxURL(url)) {
    return transformMapboxUrl(url, resourceType, MAPBOX_TOKEN);
  }
  return { url };
};

export const FULL_LOSS_COLOR = "#fcc32c";
export const PARTIAL_LOSS_COLOR = "#fa7416";
export const NEIGHBORHOOD_BOUNDARY_COLOR = "#CDC9DD";

export const defaultPointStyle = {
  "circle-color": [
    "case",
    ["==", ["to-number", ["get", "u22"]], 0],
    FULL_LOSS_COLOR,
    PARTIAL_LOSS_COLOR,
  ],
  "circle-opacity": [
    "interpolate",
    ["linear"],
    ["zoom"],
    // at initial zoom, circle opacity is near 0 to show blur effect
    10,
    ["case", ["==", ["to-number", ["get", "u22"]], 0], 0.05, 0.3],
    // at building-level zoom, circle opacity is near 1
    15,
    ["case", ["==", ["to-number", ["get", "u22"]], 0], 0.4, 0.8],
  ],
  "circle-radius": [
    "interpolate",
    ["linear"],
    ["zoom"],
    // at initial zoom, circles are smaller
    10,
    3,
    // at mid-level zoom, circles are larger
    14,
    10,
    // at building-level zoom, circles are very large
    17,
    15,
  ],
};

export const getPointStyle = () => ({
  id: "buildings",
  type: "circle",
  paint: defaultPointStyle,
});

export const getHoverStyle = () => ({
  id: "buildings-highlighted",
  type: "circle",
  source: "buildings",
  paint: {
    ...defaultPointStyle,
    "circle-color": [
      "case",
      ["==", ["to-number", ["get", "u22"]], 0],
      "#DCA206",
      "#A04200",
    ],
    "circle-opacity": 1,
  },
});

export const getClickStyle = () => ({
  id: "buildings-clicked",
  type: "circle",
  source: "buildings",
  paint: {
    ...defaultPointStyle,
    "circle-color": "#277FF9",
    "circle-opacity": 1,
    "circle-stroke-color": "#015AD5",
    "circle-stroke-width": 2,
  },
});

export const getLineStyle = () => ({
  id: "nta-boundaries",
  type: "line",
  source: "ntas",
  paint: {
    "line-width": 1,
    "line-color": NEIGHBORHOOD_BOUNDARY_COLOR,
  },
});
